module.exports = __webpack_public_path__ + "d4aa56f202d8893cd823c14f6d5ac81b.jpg";